module.exports = __webpack_public_path__ + "img/about_images_03.92818d38.png";